module.exports = __webpack_public_path__ + "img/toyosatomimi no miko_sc2.39ad7a17.png";